<template>
  <div
    v-if="user"
    class="preview"
    :class="isSelected ? 'selectedPreview' : ''"
    @click="select"
    :disabled="isSelected"
  >
    <div class="details">
      <div class="core-user-details">
        <div class="name">{{ index + " " + getName }}</div>
        <div class="sessionCount">{{ user.sessionCount }} sessions</div>
        <div class="upcoming">{{ userUpcomingSessionsCount }} upcoming</div>
      </div>
      <div class="core-bottom-details">
        <div v-if="user.lastAwardedBadgeCheckDate" class="userItem lastOnline">
          Last online: {{ checkedCalendar }}
        </div>
        <div
          class="verificationStatus"
          :class="user.verificationStatus ? 'verified' : 'unverified'"
        >
          {{ user.verificationStatus ? "Verified" : "Unverified" }}
        </div>
      </div>
    </div>
    <div class="email" v-if="allowedUserViewing">{{ user.email }}</div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "UserPreview",
  props: {
    user: Object,
    upcomingSessions: Array,
    index: Number,
    isSelected: Boolean,
    allowedUserViewing: Boolean,
  },
  computed: {
    getName() {
      let name = "";
      if (this.user.displayName) {
        name = this.user.displayName;
      } else if (this.user.firstName && this.user.lastName) {
        name = this.user.firstName + " " + this.user.lastName;
      } else {
        name = "name unset";
      }
      return name;
    },
    checkedCalendar() {
      return format(
        new Date(this.user.lastAwardedBadgeCheckDate),
        `MMMM d, y, HH:mm`
      );
    },
    userUpcomingSessionsCount() {
      let userSessions = [];
      for (var i = 0; i < this.upcomingSessions.length; i++) {
        let session = this.upcomingSessions[i];
        if (session.UIDs[0] && session.UIDs[0] == this.user._id) {
          userSessions.push(session);
        } else if (session.UIDs[1] && session.UIDs[1] == this.user._id) {
          userSessions.push(session);
        }
      }
      return userSessions && userSessions.length ? userSessions.length : 0;
    },
  },
  methods: {
    select() {
      this.$emit("select", this.user._id);
    },
  },
};
</script>